<template>
  <div class="container-fluid">
    <v-data-table
      :headers="headers"
      :items="drinks"
      sort-by="internalName"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      :loading="loading"
    >
      <template v-slot:top>
        <v-card
          color="red"
          flat
          tile
        >
          <v-toolbar dense
                     src="https://d2td6mzj4f4e1e.cloudfront.net/wp-content/uploads/sites/9/2019/04/soft-drinks.jpg"
          >
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>

        <v-toolbar flat color="white">
          <v-toolbar-title>Archiv nápojů</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          class="mr-2"
          @click="extract(item)"
        >
          mdi-archive-arrow-up
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  Name: 'DrinksDatabase',
  data: () => ({
    search: '',
    drinks: [],
    loading: true,
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název nápoje', value: 'name' },
      { text: 'Typ nápoje', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Objem', value: 'volume' },
      { text: 'Kalorie', value: 'calories' },
      { text: 'Archivováno dne', value: 'archivedAt' },
      { text: 'Akce', value: 'actions', sortable: false }
    ]
  }),
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.getDrinks()
    },
    getDrinks () {
      this.dialog = false
      this.loading = true
      this.$http.get('/admin/drinks/archive')
        .then(response => {
          this.drinks = this.keysToCamelCase(response.data)
            .filter(item => item.visible)
            .map(drink => {
              drink.timesStr = drink.timeTypes
                .map(time => time.name)
                .join(', ')
              drink.typesStr = drink.foodTypes
                .map(type => type.name)
                .join(', ')
              drink.alergensStr = drink.alergens
                .map(alergen => alergen.name)
                .join(', ')
              drink.archivedAt = drink.updatedAt.slice(0, 10)
              return drink
            })
          this.loading = false
        })
    },
    extract (item) {
      this.$http.post(`admin/drinks/${item.id}/extract`)
        .then(() => {
          this.getDrinks()
        })
    }
  }
}
</script>

<style scoped>

</style>
